// ============================================================================
// JOURNAL GLYPHS — transcribed path-for-path from docs/design/handoff/
// "LifeOS Journal.dc.html", options 5a and 5b.
//
// WHY THESE ARE NOT IN components/icons.tsx. Three screens were ported in
// parallel (Journal, School, Connections) and icons.tsx belongs to none of them.
// Adding to it from three branches at once produces three-way conflicts in a file
// whose whole job is to be boring. Chevron, Mic and Plus are GENERIC and the other
// two ports will want them: the day these branches land together, hoist them into
// components/icons.tsx and delete this file's copies. That is a merge chore, not
// a design decision.
//
// Same contract as components/icons.tsx: viewBox 0 0 24 24, fill none,
// stroke="currentColor" so the colour comes from a token class and never from a
// prop (scripts/ship-gate.sh fails on a raw hex here).
// ============================================================================

import type { IconProps } from '../icons'

function Glyph({ size = 18, strokeWidth = 1.7, className, d }: IconProps & { d: string }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      aria-hidden="true"
      focusable="false"
    >
      <path d={d} />
    </svg>
  )
}

/** Voice. The "Has voice" filter chip, and the ×N pill on a day card. */
export const Mic = (p: IconProps) => (
  <Glyph
    {...p}
    d="M12 4.6a2.8 2.8 0 0 1 2.8 2.8v4a2.8 2.8 0 0 1-5.6 0v-4A2.8 2.8 0 0 1 12 4.6M6.6 11.4a5.4 5.4 0 0 0 10.8 0M12 16.8V19.4"
  />
)

/** "Write today". */
export const Plus = (p: IconProps) => <Glyph {...p} d="M12 5.4v13.2M5.4 12h13.2" />

export const ChevronLeft = (p: IconProps) => <Glyph strokeWidth={2} {...p} d="M14 6.5 8.5 12l5.5 5.5" />
export const ChevronRight = (p: IconProps) => <Glyph strokeWidth={2} {...p} d="M10 6.5 15.5 12 10 17.5" />
export const ChevronDown = (p: IconProps) => <Glyph strokeWidth={2} {...p} d="M6.5 9.5 12 15l5.5-5.5" />

/**
 * "On this day". A clock with a flick behind it — the mockups' history glyph, and
 * NOT the same path as components/icons.tsx `Clock`, which has no flick.
 */
export const History = (p: IconProps) => (
  <Glyph {...p} d="M12 4a8 8 0 1 1 0 16 8 8 0 0 1 0-16M12 8.4V12l2.6 2.2M4.8 6.2 3.2 4.6" />
)

/** Threads. */
export const ListLines = (p: IconProps) => (
  <Glyph {...p} d="M9 7h10M9 12h10M9 17h6M5 7h.2M5 12h.2M5 17h.2" />
)
